// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-bar-container {
    width: 100%;
    background-color: #fff;
    height: 50px;
    position: fixed;
    padding: 5px 0;
    bottom: 0;
    z-index: 3;
    border: 1px solid;
    border-color: #e0e0e0 transparent transparent transparent;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.half-container {
    width: 40%;
    display: flex;
    justify-content: space-around;
}

.half-container-fa {
    width: 40%;
    height: 30%;
    display: flex;
    justify-content: space-around;
}


.icon-container {
    display: inline-flex;
    height: 100%;
    width: 20%;
    justify-content: center;
    align-items: center;
    flex-flow: column;
}

.icon-container .icon-title {
    margin: 0;
    font-size: 12px;
    color: #424242;
    text-align: center;
}

.icon-title-fa {
    width: 70px;
    margin: 0;
    font-size: 12px;
    color: #424242;
    text-align: center;
}

.center-FAB-container {
    position: absolute;
    left: 44%;
    top: -40%;
}

.center-FAB-container-fa {
    position: absolute;
    right: 44%;
    top: -40%;
}

/*.center-FAB-container {
    position: absolute;
    margin-right: 44%;
    top: -40%;
}*/

.more-row {
    padding: 15px;
    display: flex;
    align-items: center;
    align-self: flex-start;
    border-top: 2px solid #EBEBEB;
    width: -webkit-fill-available;
}

.more-row-img {
    width: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.more-row img {
    padding-right: 15px;
}

.more-row:hover {
    cursor: pointer;
}

@media screen and (min-width: 600px) and (max-width: 1000px) {
    .center-FAB-container {
        left: 46%;
    }
}

@media print {
    .bottom-bar-container {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/css/bottom-bar.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,yDAAyD;IACzD,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,6BAA6B;AACjC;;;AAGA;IACI,oBAAoB;IACpB,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;;;;EAIE;;AAEF;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".bottom-bar-container {\n    width: 100%;\n    background-color: #fff;\n    height: 50px;\n    position: fixed;\n    padding: 5px 0;\n    bottom: 0;\n    z-index: 3;\n    border: 1px solid;\n    border-color: #e0e0e0 transparent transparent transparent;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n}\n\n.half-container {\n    width: 40%;\n    display: flex;\n    justify-content: space-around;\n}\n\n.half-container-fa {\n    width: 40%;\n    height: 30%;\n    display: flex;\n    justify-content: space-around;\n}\n\n\n.icon-container {\n    display: inline-flex;\n    height: 100%;\n    width: 20%;\n    justify-content: center;\n    align-items: center;\n    flex-flow: column;\n}\n\n.icon-container .icon-title {\n    margin: 0;\n    font-size: 12px;\n    color: #424242;\n    text-align: center;\n}\n\n.icon-title-fa {\n    width: 70px;\n    margin: 0;\n    font-size: 12px;\n    color: #424242;\n    text-align: center;\n}\n\n.center-FAB-container {\n    position: absolute;\n    left: 44%;\n    top: -40%;\n}\n\n.center-FAB-container-fa {\n    position: absolute;\n    right: 44%;\n    top: -40%;\n}\n\n/*.center-FAB-container {\n    position: absolute;\n    margin-right: 44%;\n    top: -40%;\n}*/\n\n.more-row {\n    padding: 15px;\n    display: flex;\n    align-items: center;\n    align-self: flex-start;\n    border-top: 2px solid #EBEBEB;\n    width: -webkit-fill-available;\n}\n\n.more-row-img {\n    width: 45px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.more-row img {\n    padding-right: 15px;\n}\n\n.more-row:hover {\n    cursor: pointer;\n}\n\n@media screen and (min-width: 600px) and (max-width: 1000px) {\n    .center-FAB-container {\n        left: 46%;\n    }\n}\n\n@media print {\n    .bottom-bar-container {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
